"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

const IconPCMonitoring = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/_react.default.createElement("title", null, title) : null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.327 1.897a1 1 0 011 1v5.065a6.229 6.229 0 00-1.4.709V3.297h-8.2v17.2h8.2v-1.463c.431.292.901.531 1.4.709v1.155a1 1 0 01-1 1h-9a1 1 0 01-1-1v-18a1 1 0 011-1h9zm-3.5 15.8a.7.7 0 01.095 1.394l-.095.006h-2a.7.7 0 01-.095-1.393l.095-.006h2zm-1-11.8a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm0 1.4a1.1 1.1 0 100 2.2 1.1 1.1 0 000-2.2z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.423 9.103a4.75 4.75 0 013.839 7.548l3.997 4.168a.75.75 0 01-.977 1.133l-.084-.073-4.001-4.17a4.75 4.75 0 11-2.774-8.606zm0 1.5a3.25 3.25 0 102.259 5.586.27.27 0 01.035-.042l.04-.034a3.25 3.25 0 00-2.335-5.51z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.743 12.243a.75.75 0 011.093 1.02l-.076.082-1.253 1.157a.75.75 0 01-.593.194l-.107-.02-.832-.22-.912 1.021a.75.75 0 01-.97.127l-.089-.067a.75.75 0 01-.127-.971l.068-.088 1.218-1.363a.75.75 0 01.648-.245l.103.02.877.23.952-.877z"
  }));
};

const ForwardRef = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(IconPCMonitoring, (0, _extends2.default)({
  svgRef: ref
}, props)));

var _default = ForwardRef;
exports.default = _default;